import { Heading } from 'components/text';
import Image from 'next/image';
import styles from 'blocks/travel-journal-articles/home/hero-section/HeroSection.module.scss';
import Container from 'components/container';
import { travelJournalHeroWEBP } from 'assets';
import { TravelJournalCategoryType } from 'types/types';
import CategoryLink from 'blocks/travel-journal-articles/home/category-link';

interface HeroSectionProps {
  selectedCategory: TravelJournalCategoryType;
  categories: TravelJournalCategoryType[];
}

const HeroSection: React.FC<HeroSectionProps> = ({
  selectedCategory,
  categories,
}) => {
  return (
    <Container as="header" className={styles.heroSection}>
      <h1 className={styles.title}>{selectedCategory.name}</h1>
      <Image
        src={selectedCategory.image || travelJournalHeroWEBP}
        objectPosition="center"
        objectFit="cover"
        alt={`Travel Journal | ${selectedCategory.name}`}
        layout="fill"
        sizes="200vw"
      />
      <nav className={styles.categories}>
        {categories.map(category =>
          category.slug === selectedCategory.slug ? (
            <div key={category.id} className={styles.active}>
              {category.name}
            </div>
          ) : (
            <CategoryLink key={category.id} category={category}>
              {category.name}
            </CategoryLink>
          )
        )}
      </nav>
      <Container className={styles.bottomGradient} />
    </Container>
  );
};

export default HeroSection;
